import { Injectable } from 'angular-ts-decorators';

import type { SessionStorage } from '@shared/app/scripts/services/session-storage';

/**
 * Service that wrapps {@link SessionStorage}, and works with json instead of
 * strings.
 */
@Injectable('sessionJsonStorage')
export class SessionJsonStorage {
  constructor(private sessionStorage: SessionStorage) {
    'ngInject';
  }

  /**
   * @param key identifier
   * @param value to be saved
   * @param {any} arg
   */
  setItem<T = any>(key: string, value: T) {
    this.sessionStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Read value from storage
   * @param key identifier
   * @return {T}
   * Value that was stored
   */
  getItem<T = any>(key: string): T {
    return <T>JSON.parse(this.sessionStorage.getItem(key));
  }

  /**
   * Removes stored value
   * @param key identifier
   */
  removeItem(key: string) {
    return this.sessionStorage.removeItem(key);
  }
}
